import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ProcedureEnum } from '@core/procedure-helpers/models/procedure.enum';
import { BaseDestroyableComponent } from '@shared/base-classes/base-destroyable';
import { RxModel } from '@shared/models/rx-models/interfaces/rx-model';

@Component({
	selector: 'rx-teeth-diagram',
	template: `
		<ng-container [ngSwitch]="diagramType">
			<rx-teeth-diagram-v0
				(imagesLoaded)="imagesLoaded.emit($event)"
				*ngSwitchCase="'caseType'"
				[rxForPrint]="rxForPrint"
				[isRxForModeling]="isRxForModeling"
			></rx-teeth-diagram-v0>
			<rx-teeth-diagram-v1
				(imagesLoaded)="imagesLoaded.emit($event)"
				*ngSwitchCase="'procedureFlow'"
				[rxForPrint]="rxForPrint"
				[isRxForModeling]="isRxForModeling"
			></rx-teeth-diagram-v1>
			<rx-teeth-diagram-v1
				(imagesLoaded)="imagesLoaded.emit($event)"
				*ngSwitchCase="'art'"
				[rxForPrint]="rxForPrint"
				[isRxForModeling]="false"
			></rx-teeth-diagram-v1>
		</ng-container>
	`
})
export class TeethDiagramComponent extends BaseDestroyableComponent {
	@Input() rxForPrint: RxModel;
	@Input() isRxForModeling: boolean;
	@Input() isProcedureFlow: boolean;

	@Output() imagesLoaded = new EventEmitter<void>();

	get diagramType(): 'caseType' | 'procedureFlow' | 'art' {
		if(this.rxForPrint?.Order?.ProcedureId === ProcedureEnum.InvisalignART) {
			return 'art';
		}
		if(this.isProcedureFlow) {
			return 'procedureFlow';
		}
		return 'caseType';
	}

	constructor() {
		super();
	}
}
